<template>
  <div>
    <div class="form-group w-100 d-flex align-items-center">
      <div class="col-10">
        <label for="helpId"
               class="label">Buscar mensalistas</label>
        <input id="helpId"
               v-model="pesquisar"
               type="text"
               class="form-control"
               placeholder="Digite o nome do mensalista">
      </div>
      <div v-if="loader"
           class="col pt-4">
        <b-spinner variant="primary"
                   label="Spinning" />
      </div>   
    </div>
  </div>
</template>

<script>
  // Services
  import MensalistaService from '../mensalistaService'

  export default ({
    name: 'BuscaMensalistas',
    data () {
      return {
        pesquisar: '',
        loader: false,
      }
    },
    watch: {
      'pesquisar' () {
        this.pesquisarPorNome(this.pesquisar)
      }
    },
    methods: {
      async pesquisarPorNome (text) {
        try {
          if (text.length >= 3) {
            this.loader = true
            const mensalistas = await MensalistaService.getPesquisa(text)
            this.$store.dispatch('frenteCaixa/atualizarMensalistas', mensalistas)
          }
          if (text.length > 1 && text.length < 3) {
            this.loader = true
            const todosMensalistas = await MensalistaService.getMensalistas()
            this.$store.dispatch('frenteCaixa/atualizarMensalistas', todosMensalistas)
          }
        } catch (err) {
          console.log('BuscaMensalistas', err)
        } finally {
          this.loader = false
        }
      },
    }
  })
</script>

<style scoped>
.label {
    font-weight: 500;
    padding-bottom: 5px;
}

</style>